import React, { useState } from "react";
import globalMU from "../../../globalMU";
import { classeParaLabelsFormularioComFundoEscuroSimplificada } from "app/estilos/classeParaLabelsFormularioComFundoEscuro";
import clsx from "clsx";
import { InputNumerico } from "../inputs/InputNumerico";
import { Separador } from "../separador/Separador";
import { InputData } from "../inputs/InputData";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import { prop } from "ramda";

const estiloTabela = require('../../estilos/tabelas.module.scss').default
const estilosFormulario = require('../../estilos/formulario.module.scss').default
//const estilosBotoes = require('../../estilos/botoes.module.scss').default

const estilo = require("./AnaliseGerencialProduitoItem.module.scss").default;


export type FiltroAnaliseGerencialProdutoItem = {
  IdProduto: string
  IdentificadorOrcamento: string

}

export type RoteiroProdutoItem = {
  Codigo: string
  Descricao: string
  Percentual: number
}

export type DadosAnaliseGerencialProdutoItem = {
  IdProduto: string
  CodigoProduto: string
  Descricao: string
  ValorUnitarioUltimaNotaFiscal: number
  DataUltimaCompra: Date
  CustoUltimaCompra: number
  QuantidadeUltimaCompra: number
  CustoReal: number
  DataUltimaRemarcacao: Date
  PercentualCustoOperacional1: number
  PercentualCustoOperacional2: number
  PercentualCustoOperacional3: number
  PercentualMarkup1: number
  PercentualMarkup2: number
  ConsiderarPercentualFreteProduto: boolean
  PercentualVariacaoFrete: number
  PercentualFreteRoteiro1: number
  AplicarPercentualVariacaoTodosRoteiros: boolean
  PercentualDescontoRetira: number
  PrecoRetira: number
  PrecoEntrega: number
  SugestaoPrecoRetira: number
  SugestaoPrecoEntrega: number
  PercentualSubstituicaoTributaria: number
  PercentualIpi: number
  PercentualEmbalagem: number
  PercentualFrete: number
  PercentualOutras: number
  Roteiros: RoteiroProdutoItem[]
};


export type AnaliseGerencialProdutoItemProps = {
  dados: DadosAnaliseGerencialProdutoItem
  onRenderizarConsultaSimulacaoDePreco: () => void
};

export const AnaliseGerencialProdutoItem = (props: AnaliseGerencialProdutoItemProps) => {
  const [dados, setDados] = useState<DadosAnaliseGerencialProdutoItem>(props.dados);


  const descricaoProdutoSelecionado = <section className={clsx(estilosFormulario.formularioSimplificado, classeParaLabelsFormularioComFundoEscuroSimplificada)}>
    <label>Produto</label><span>{props?.dados?.CodigoProduto}</span>
    <label>Descrição</label><span>{props?.dados?.Descricao}</span>
  </section>

  const grupo1 = () => {
    const valorUnitarioUltimaNf = <div>
      <label>Valor Unitário Última NF</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_valorUnitarioUltimaNf"
        numeroCasasDecimais={6}
        valor={props.dados?.ValorUnitarioUltimaNotaFiscal ?? 0} />
    </div>

    const custoUltimaCompra = <div>
      <label>Custo Última Compra</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_custoUltimaCompra"
        numeroCasasDecimais={6}
        valor={props.dados?.CustoUltimaCompra ?? 0} />
    </div>

    const custoReal = <div>
      <label>Custo Real</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_custoReal"
        numeroCasasDecimais={6}
        valor={props.dados?.CustoReal ?? 0} />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo_1"
      className={estilo.form}>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {valorUnitarioUltimaNf}
          {custoUltimaCompra}
          {custoReal}
        </div>

      </div>

    </div>
  }

  const grupo2 = () => {

    const botaoUltimaPesquisaPreco = <div>
      <button className={estilo.botao}
        onClick={props.onRenderizarConsultaSimulacaoDePreco}
        id="AnaliseGerencialProdutoItem_botaoUltimaPesquisaPreco">
        Última Pesquisa de Preço
      </button>
    </div>

    const dataUltimaCompra = <div>
      <label>Data Última Compra</label>
      <InputData
        disabled
        data={globalMU.formatDate(props.dados?.DataUltimaCompra)}
      />
    </div>

    const quantidadeUltimaCompra = <div>
      <label>Quantidade Última Compra</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_QuantidadeUltimaCompra"
        numeroCasasDecimais={3}
        valor={props.dados?.QuantidadeUltimaCompra ?? 0} />
    </div>

    const dataUltimaRemarcacao = <div>
      <label>Data Última Remarcação</label>
      <InputData
        disabled
        data={globalMU.formatDate(props.dados?.DataUltimaRemarcacao)}
      />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo2"
      className={estilo.form}>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {dataUltimaCompra}
          {quantidadeUltimaCompra}
          {dataUltimaRemarcacao}
        </div>
      </div>
      {botaoUltimaPesquisaPreco}
    </div>
  }

  const grupo3_ComposicaoCustoVenda = () => {
    const percentualCustoOperacional1 = <div>
      <label>% Custo Operacional 1</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_PercentualCustoOperacional1"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualCustoOperacional1 ?? 0} />
    </div>

    const percentualCustoOperacional2 = <div>
      <label>% Custo Operacional 2</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_PercentualCustoOperacional2"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualCustoOperacional2 ?? 0} />
    </div>

    const percentualCustoOperacional3 = <div>
      <label>% Custo Operacional 3</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_PercentualCustoOperacional3"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualCustoOperacional3 ?? 0} />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo_3_ComposicaoCustoVenda"
      className={estilo.form}>
      <label className={estilo.titulo}>Composição Custo de Venda</label>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {percentualCustoOperacional1}
          {percentualCustoOperacional2}
          {percentualCustoOperacional3}
        </div>
      </div>
    </div>
  }

  const grupo4_MarkupComposto = () => {
    const PercentualMarkup1 = <div>
      <label>% Mark-Up 1</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_PercentualCustoOperacional1"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualMarkup1 ?? 0} />
    </div>

    const PercentualMarkup2 = <div>
      <label>% Mark-Up 2</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_PercentualCustoOperacional2"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualMarkup2 ?? 0} />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo_4_MarkupComposto"
      className={estilo.form}>
      <label className={estilo.titulo}>Mark-Up Composto</label>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {PercentualMarkup1}
          {PercentualMarkup2}
        </div>
      </div>
    </div>
  }

  const grupo5_FretePorRoteiro = () => {
    const considerarPercentualFreteProduto = <div>
      <label htmlFor="AnaliseGerencialProdutoItem_considerarPercentualFreteProduto" style={{ cursor: 'pointer' }}>Considerar o % Frete do Produto</label>
      <input
        disabled
        type="checkbox"
        id="AnaliseGerencialProdutoItem_considerarPercentualFreteProduto"
        checked={props.dados?.ConsiderarPercentualFreteProduto ?? false}
      />
    </div>

    const percentualVariacaoDoFrete = <div>
      <label>% Variação do Frete</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualVariacaoDoFrete"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualVariacaoFrete ?? 0} />
    </div>

    const percentualFreteRoteiro1 = <div>
      <label>% Frete Roteiro 1</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualFreteRoteiro1"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualFreteRoteiro1 ?? 0} />
    </div>

    const aplicarPercentualVariacaoTodosRoteiros = <div>
      <label htmlFor="AnaliseGerencialProdutoItem_aplicarPercentualVariacaoTodosRoteiros"
        style={{ cursor: 'pointer' }}>Aplicar % Variação em Todos Roteiros</label>
      <input
        disabled
        type="checkbox"
        id="AnaliseGerencialProdutoItem_aplicarPercentualVariacaoTodosRoteiros"
        checked={props.dados?.AplicarPercentualVariacaoTodosRoteiros ?? false}
      />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo_5_FretePorRoteiro"
      className={estilo.form}>
      <label className={estilo.titulo}>% Frete Por Roteiro</label>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {considerarPercentualFreteProduto}
          {percentualVariacaoDoFrete}
          {percentualFreteRoteiro1}
          {aplicarPercentualVariacaoTodosRoteiros}
        </div>
      </div>
    </div>
  }

  const grupo6_DadosGerenciaisVenda = () => {
    const percentualDescontoRetira = <div>
      <label>% Desconto Retira</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualDescontoRetira"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualDescontoRetira ?? 0} />
    </div>

    const precoRetira = <div>
      <label>Preço Retira</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_precoRetira"
        numeroCasasDecimais={2}
        valor={props.dados?.PrecoRetira ?? 0} />
    </div>

    const precoEntrega = <div>
      <label>Preço Entrega</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_precoEntrega"
        numeroCasasDecimais={2}
        valor={props.dados?.PrecoEntrega ?? 0} />
    </div>

    const sugestaoPrecoRetira = <div>
      <label>Sugestão Preço Retira</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_sugestaoPrecoRetira"
        numeroCasasDecimais={2}
        valor={props.dados?.SugestaoPrecoRetira ?? 0} />
    </div>

    const sugestaoPrecoEntrega = <div>
      <label>Sugestão Preço Entrega</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_sugestaoPrecoEntrega"
        numeroCasasDecimais={2}
        valor={props.dados?.SugestaoPrecoEntrega ?? 0} />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo_6_DadosGerenciaisVenda"
      className={estilo.form}>
      <label className={estilo.titulo}>Dados Gerenciais de Venda</label>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {percentualDescontoRetira}
          {precoRetira}
          {precoEntrega}
          {sugestaoPrecoRetira}
          {sugestaoPrecoEntrega}
        </div>
      </div>
    </div>
  }

  const grupo7_ComposicaoCompras = () => {
    const percentualSubstituicaoTributaria = <div>
      <label>% Subst. Tributária</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualSubstituicaoTributaria"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualSubstituicaoTributaria ?? 0} />
    </div>

    const percentualIpi = <div>
      <label>% IPI</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualIpi"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualIpi ?? 0} />
    </div>

    const percentualEmbalagem = <div>
      <label>% Embalagem</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualEmbalagem"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualEmbalagem ?? 0} />
    </div>

    const percentualFrete = <div>
      <label>% Frete</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualFrete"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualFrete ?? 0} />
    </div>

    const percentualOutras = <div>
      <label>% Outras</label>
      <InputNumerico
        disabled
        id="AnaliseGerencialProdutoItem_percentualOutras"
        numeroCasasDecimais={3}
        valor={props.dados?.PercentualOutras ?? 0} />
    </div>

    return <div
      id="AnaliseGerencialProdutoItem_grupo_7_ComposicaoCompras"
      className={estilo.form}>
      <label className={estilo.titulo}>Composição de Compras</label>
      <div className={estilo.itensAEsquerda}>
        <div className={estilo.analiseGerencial}>
          {percentualSubstituicaoTributaria}
          {percentualIpi}
          {percentualEmbalagem}
          {percentualFrete}
          {percentualOutras}
        </div>
      </div>
    </div>
  }

  const grupo8_ListaRoteiros = () => {

    return <>{props?.dados?.ConsiderarPercentualFreteProduto && props?.dados?.Roteiros &&
      <div
        id="AnaliseGerencialProdutoItem_grupo_8_ListaRoteiros"
        className={estilo.form}>
        <label className={estilo.titulo}>Lista de Roteiros</label>
        <div className={estiloTabela.containerRolavel}>
          <table className={clsx(estiloTabela.tabela, "_w-full")} id="AnaliseGerencialProdutoItem_ListaRoteiros">
            <thead>
              <tr >
                <th className={estiloTabela.cabecalhoTexto}>Código</th>
                <th className={estiloTabela.cabecalhoTexto}>Descrição</th>
                <th className={estiloTabela.cabecalhoNumerico}>% Frete</th>
              </tr>
            </thead>
            <tbody>
              {(props?.dados?.Roteiros ?? []).map(roteiro =>
                <tr key={roteiro.Codigo} className={`_table-row ${estiloTabela.dadoTexto} ${estiloTabela.linhaClicavel}`}>
                  <td>{roteiro.Codigo}</td>
                  <td>{roteiro.Descricao}</td>
                  <td className={estiloTabela.dadoNumerico}>{globalMU.formatarValorNumerico(roteiro.Percentual, 2, false)}</td>
                </tr>
              )}

            </tbody>
          </table>
        </div>
      </div>
    }</>
  }

  return (
    <>
      {descricaoProdutoSelecionado}
      <div className={`_mt-4 _grid _grid-cols-1 min-[992px]:_grid-cols-2`} style={{ borderTop: "1px solid rgba(0, 0, 0, 0.05)", paddingTop: "5px" }}>
        {grupo1()}
        {grupo2()}
      </div>

      <div className={`_mt-4 _grid _grid-cols-1 min-[992px]:_grid-cols-2`} style={{ borderTop: "1px solid rgba(0, 0, 0, 0.05)", paddingTop: "5px" }}>
        {grupo3_ComposicaoCustoVenda()}
        {grupo4_MarkupComposto()}
      </div>

      <div className={`_mt-4 _grid _grid-cols-1 min-[992px]:_grid-cols-2`} style={{ borderTop: "1px solid rgba(0, 0, 0, 0.05)", paddingTop: "5px" }}>
        {grupo5_FretePorRoteiro()}
        {grupo6_DadosGerenciaisVenda()}
        {grupo7_ComposicaoCompras()}
      </div>
      <div className={`_mt-4 _grid _grid-cols-1 min-[992px]:_grid-cols-1`} style={{ borderTop: "1px solid rgba(0, 0, 0, 0.05)", paddingTop: "5px" }}>
        {grupo8_ListaRoteiros()}
      </div>
      <section style={{ marginBottom: "100px" }} />
    </>)
}
